import React from 'react';
import { MapIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../profile/Urls';
import DataCard from './DataCard';

export default function ZipCode(props) {
  const { user } = props;

  const { history } = useRouter();

  return (
    <DataCard
      title="ZIP Code"
      icon={MapIcon}
      subtitle={user.data.zipCode || '(not provided)'}
      onClick={() => history.push(Urls(user).LOCATION)}
    />
  );
};
